'use client';

import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { motion } from 'motion/react';
import { useLlm } from '../../../useLlm/useLlm';
import { useLlmView } from '../../../useLlm/useLlmView';
import { messageMapper } from '../../utils';
import { Canvas } from '../Canvas/canvas';

const MinimizeButton: React.FC<{ onClick: (e: React.MouseEvent) => void; label: string }> = ({ onClick, label }) => (
  <button type="button" className="llm__trigger-minimize" onClick={onClick} aria-label={label}>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  </button>
);

export const Trigger: React.FC = () => {
  const theme = useLlm((state) => state.theme);
  const { Blob } = useLlm((state) => state.components);
  const app = useLlm((state) => state.app);
  const opened = useLlmView((state) => state.opened);
  const minimized = useLlmView((state) => state.minimized);
  const { open, setMinimized } = useLlmView((state) => state.actions);
  const label = useLabel();
  const enableMinimize = app?.contents.enableMinimize;
  const collapsedWelcomeText = messageMapper(
    app?.contents.collapsedWelcomeText
  );
  const collapsedWelcomeTextCta = messageMapper(
    app?.contents.collapsedWelcomeTextCta
  );
  const collapsedWelcomeTextHover = messageMapper(
    app?.contents.collapsedWelcomeTextHover
  );
  const position = theme.trigger?.position || 'bottom';
  return (
    <motion.nav
      className={getClassNames('llm__trigger', '-' + position, {
        '-minimized': minimized,
      })}
      initial={{ y: '200%', opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: '200%', opacity: 0 }}
      transition={{ duration: 0.4 }}
      aria-label="Trigger"
      /*
      aria-expanded={opened}
      aria-controls={mainId}
      */
      onClick={() => open()}
    >
      <button
        type="button"
        className={getClassNames('llm__trigger-btn', {
          'llm__trigger-btn--hover': collapsedWelcomeTextHover !== undefined,
        })}
      >
        <Blob />
        <span>{label('llm.button')}</span>
      </button>
      {!opened &&
        !minimized &&
        (collapsedWelcomeText ||
          collapsedWelcomeTextCta ||
          collapsedWelcomeTextHover) && (
        <div className="llm__trigger-popup -llm-t-body2">
          {(collapsedWelcomeText || collapsedWelcomeTextCta) && (
            <motion.div
              className="llm__trigger-message"
              exit={{
                opacity: 0,
              }}
            >
              <Canvas />
              {collapsedWelcomeText}
              {enableMinimize && (
                <MinimizeButton
                  onClick={(e) => {
                    e.stopPropagation();
                    setMinimized(true);
                  }}
                  label={label('llm.minimize') || 'Minimize'}
                />
              )}
              {collapsedWelcomeTextCta && (
                <button type="button" className="llm__trigger-cta">
                  {collapsedWelcomeTextCta}
                </button>
              )}
            </motion.div>
          )}
          {collapsedWelcomeTextHover && (
            <motion.div
              className="llm__trigger-message"
              exit={{
                opacity: 0,
              }}
            >
              <Canvas />
              {collapsedWelcomeTextHover}
            </motion.div>
          )}
        </div>
      )}
    </motion.nav>
  );
};
